import LifeCycleModule from "./LifeCycleModule";
var life_cycle_module_default = LifeCycleModule;
export {
  life_cycle_module_default as default
};
